// import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import { getLoginStatus } from "@/services/api";

const state = {
  token: getToken(),
  name: "",
  menus: [],
  //   avatar: "",
  //   introduction: "",
  roles: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    // console.log("token", token);
    state.token = token;
  },
  //   SET_INTRODUCTION: (state, introduction) => {
  //     state.introduction = introduction;
  //   },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_MENUS: (state, menu) => {
    state.menus = menu;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  //动态注册路由   不同的账号菜单不一样  能路由的地方不一样
  addMenu(state, router) {
    if (!localStorage.getItem("menu")) {
      return;
    }
    const menu = JSON.parse(localStorage.getItem("menu"));
    state.menus = menu;
    // 深度解析JSON字符串的辅助函数
    const deepParseJSON = (value) => {
      // 如果是字符串，尝试解析
      if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          // 递归解析，处理嵌套的JSON字符串
          return deepParseJSON(parsed);
        } catch (e) {
          // 如果解析失败，返回原始字符串
          return value;
        }
      }
      // 如果是对象，递归处理每个属性
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const result = {};
        for (const key in value) {
          result[key] = deepParseJSON(value[key]);
        }
        return result;
      }
      // 如果是数组，递归处理每个元素
      if (Array.isArray(value)) {
        return value.map((item) => deepParseJSON(item));
      }
      // 其他类型直接返回
      return value;
    };

    // 解析config字段并合并到路由配置的辅助函数
    const parseMenuConfig = (menuItem) => {
      const routeConfig = { ...menuItem };

      // 解析config字段
      if (menuItem.config && typeof menuItem.config === "string") {
        try {
          const configData = JSON.parse(menuItem.config);
          // 深度解析config中的每个值（处理字符串化的数组、对象等）
          const parsedConfig = deepParseJSON(configData);
          // 将config中的数据合并到路由配置中
          Object.assign(routeConfig, parsedConfig);
          // console.log(`解析 ${menuItem.label || menuItem.name} 的config:`, parsedConfig);
        } catch (e) {
          // console.warn(`解析菜单 ${menuItem.label || menuItem.name} 的config失败:`, e);
        }
      }

      return routeConfig;
    };
    //组装动态路由的数据
    const menuArray = [];
    menu.forEach((item) => {
      //old
      //    有子菜单
      //   if (item.children) {
      //     item.children = item.children.map((item) => {
      //       item.component = () => import(`../views/${item.url}`);
      //       return item;
      //     });
      //     menuArray.push(...item.children);
      //   } else {
      //     //无子菜单
      //     item.component = () => import(`../views/${item.url}`);
      //     menuArray.push(item);
      //   }

      //有子菜单
      if (item.children) {
        item.children.forEach((child) => {
          if (child.url) {
            // 解析config配置
            const routeConfig = parseMenuConfig(child);
            routeConfig.component = () => import(`../views/${child.url}`);
            menuArray.push(routeConfig);
          }
        });
      } else {
        //无子菜单
        if (item.url) {
          // 解析config配置
          const routeConfig = parseMenuConfig(item);
          routeConfig.component = () => import(`../views/${item.url}`);
          menuArray.push(routeConfig);
        }
      }
    });
    //路由的动态添加
    menuArray.forEach((item) => {
      router.addRoute("Main", item);
    });
  },
};

const actions = {
  // 用户 登录
  login({ commit }, userInfo) {
    const { name, password } = userInfo;
    return new Promise((resolve, reject) => {
      getLoginStatus({ name: name?.trim(), password: password })
        .then(async (response) => {
          const { data } = response;
          // 菜单信息存到localstorage中，方便刷新页面后获取菜单信息
          localStorage.setItem("menu", JSON.stringify(data.data.menus));
          localStorage.setItem("roleList", JSON.stringify(data.data.roles));
          localStorage.setItem("pUserName", data.data.name);
          localStorage.setItem("pUserId", data.data.userId);
          resetRouter();
          commit("SET_TOKEN", data.data.token);
          setToken(data.data.token);

          commit("SET_ROLES", data.data.roles);
          commit("SET_NAME", data.data.name); //用户名
          commit("SET_MENUS", data.data.menus);
          commit("addMenu", router);
          //   console.log("router.getRoutes()", router.getRoutes());
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
